import { useMemo } from "react";

import { useAllSalesFunnels } from "~/modules/client/api/salesFunnel/salesFunnelQueries.ts";
import type { FormInputOption } from "~/types/form.ts";
import { createInputOptionData,getInputDefaultOptionsData } from "~/utils/form/formUtils.ts";
import { byObjectProperty } from "~/utils/sortFunctions.ts";


const useSalesFunnelSelectOptions = (includeCtaOption: boolean = false): FormInputOption[] => {
	const { data: salesFunnelData } = useAllSalesFunnels();
	return useMemo(() => {
		if (salesFunnelData) {
			const options = salesFunnelData.sort(byObjectProperty("listPosition")).map((salesFunnel) => {
				return createInputOptionData(salesFunnel.displayName, salesFunnel.id);
			});

			if (includeCtaOption) {
				return [getInputDefaultOptionsData(), ...options];
			}
			return options;
		}
		return [];
	}, [salesFunnelData, includeCtaOption]);
};

export default useSalesFunnelSelectOptions;

